export default {
  Role: "Rol",
  action: "acción",
  activation_date: "Fecha de activación",
  active: "activo",
  add: "Añadir",
  addAlbumName: "Añadir titulo de álbum",
  addSelectedToClaimList: "Añadir al área de trabajo de titularidad",
  addedToClaimList: "Added to Claim List",
  additional_data: "datos adicionales",
  additions_pct: "Porcentaje de adiciones",
  address: "Dirección",
  agent: "agente",
  airdatetime: "Fecha de lanzamiento",
  all_fields_must_be_filled: "Todos los campos tienen que estar rellenados",
  artist: "Artista",
  auto_manually_matched: "automanualmente identificado",
  automatched: "identificado automáticamente",
  automatchedCheckboxInfo: "Selecciona esta opción para lanzar el proceo de identificación de usos  (no se modificarán usos manualmente identificados )",
  blocked: "bloqueado",
  cancel: "Cancelar",
  chooseFileOrDrag: "Seleccione un fichero o arrastrelo aquí",
  choose_mandates_before_activation: "por favor seleccione mandatos antes de activar usuarios",
  claim: "reclamar titularidad",
  claimAll: "reclamar toda la titularidad",
  claimPercentage: "propiedad %",
  claimStatus: "Estado de la titularidad",
  claimWorkspace: "Área de trabajo de titularidad",
  claim_edited: "Titularidad editada",
  claimed: "titularidad completa",
  claiming: "Titularidad en curso",
  claims: "información de titularidad",
  clear: "limpiar",
  clearFilters: "limpiar filtros",
  clear_all: "deseleccionar todo",
  collapse: "colapsar",
  companyName: "nombre de la compañía",
  company_profile: "perfil de compañía",
  confirm_finalize_distribution: "Por favor tenga en cuenta que al finalizar la distribución se publicarán los informes de distribución individuales para sus miembros y ya no podrá modificarlos. ¿Desea continuar?",
  confirm_validate: "confirmar validación",
  congratulations: "felicidades",
  continue: "continuar",
  create: "crear",
  createNewSoundRecording: "crear nuevo fonograma",
  createPlaceholder: "crear fonograma",
  create_user: "crear usuario",
  create_user_for: "crear usuario para",
  created: "creado",
  date: "fecha",
  deduction_pct: "deduction %",
  defaultMatchingInfo: "Por defecto, sólo los usos no identificados serán incluidos en el proceso de identificación",
  delete: "borrar",
  deleteClaims: "borrado masivo de reclamaciones",
  delete_distribution: "Borrar Distribución",
  delete_distribution_warning: "¿Está seguro de que quiere borrar este borrador de distribución?",
  deleted: "borrado",
  dismiss: "descartar",
  distribution: "distribución",
  distribution_deleted: "distribución eliminada",
  distribution_saved: "distribución guardada",
  distributions: "distribuciones",
  domestic: "domestico",
  download: "descarga",
  downloadFile: "descargar fichero",
  downloadSampleFile: "descargar fichero de muestra",
  downloadSampleFileNote: "NOTA: Los ficheros de muestra dependen del tipo de uso seleccionado, ficheros descargados anteriormente puede no funcionar",
  downloadTemplate: "descargar plantilla",
  duration: "duración",
  editClaim: "editar información de titularidad",
  editClaims: "edición masiva de reclamaciones",
  editDistribution: "editar distribución",
  editDistributionForFile: "Editar distribución por archivo de fondos:",
  edit_org: "editar perfil de compañía",
  email: "correo electrónico",
  email_format_not_valid: "correo electrónico con formato no válido",
  email_not_defined: "introducir correo electrónico",
  email_sent: "correo electrónico enviado",
  error: "error",
  errors: "errores",
  exclude_members: "Excluir Miembros",
  exclude_members_modal_header: "Excluir Miembros del Fondo",
  exclude_members_modal_sub_text: "Habitualmente SoundSys distribuye a todos los miembros que tengan un mandato válido. Si algunos miembros tienen licencias directas o no deberían participar en este fondo, se pueden excluir aquí. Los miembros seleccionados no participarán en la distribución de este fondo.",
  expired_session: "Your session has expired! Please login",
  extras: "extras",
  field: "campo",
  fileName: "nombre del archivo",
  fileType: "tipo de fichero",
  file_uploaded: "fichero cargado!",
  filterFiles: "filtrar ficheros",
  filterSoundRecordings: "filtrar fonogramas",
  filterTimePeriod: "filtrar periodo",
  filters: "filtros",
  finishSetup: "acabar setup",
  fixation_country: "país de grabación",
  fixation_year: "año",
  forgot_your_password: "Olvidé mi contraseña",
  from: "de",
  funds: "fondos",
  generatePreDistributionReport: "generar informe de predistribución",
  generateUnmatchedReport: "generar informe de no identificados",
  generatedReportWillBeSent: "se le enviará por correo electrónico el informe generado",
  genres: "géneros",
  go_back: "atrás",
  go_to_users: "ir a usuarios",
  gross_amount: "Cantidad bruta",
  hide: "oculto",
  history: "historial",
  ingested: "cargado",
  ingestionStats: "Informe de carga",
  invalid_data_range: "Rango de fechas invalido",
  invalid_split_range: "El valor de la propuedad debe estar comprendido entre 0 y 100",
  invalid_split_value: "Valor de propiedad inválido",
  invalid_time_format: "Formato de tiempo invalido",
  invalidateSource: "invalidate source",
  invalidateSourceInfo: "Warning. You are removing this instance data. It will no longer appear in the UI.",
  invalidatedSource: "source invalidated",
  isEligible: "elegible",
  isrc: "ISRC",
  item: "Artículo",
  landed: "descargado",
  landed_sound_recordings: "fonogramas descargados",
  lang_of_perf: "idioma",
  language: "idioma",
  licensee: "licenciatario",
  linked: "enlazado",
  log_in: "iniciar sesión",
  login: "iniciar sesión",
  logout: "cerrar sesión",
  makeAClaim: "gestionar titularidad",
  manually_created: "creado manualmente",
  manually_linked: "enlazado manualmente",
  manually_matched: "identificado manualmente",
  match: "identificar",
  matched: "identificado",
  matchingStats: "info. proceso de identificación",
  member: "sello",
  memberProfile: "perfil sello",
  memberSociety: "sello / sociedad",
  member_not_defined: "el nombre del sello es obligatorio",
  member_saved: "sello guardado",
  members: "sellos",
  missing_required_fields: "faltan campos obligatorios",
  myProfile: "mi perfil",
  name: "nombre",
  name_and_last_name: "nombre y apellido",
  name_and_last_name_not_defined: "nombre y apellido no definidos",
  nationality: "nacionalidad",
  net_amount: "Cantidad neta",
  newDistribution: "nueva distribución",
  new_member_signup: "registro nuevo sello",
  no: "no",
  nothingToAdd: "Nothing to add",
  notifications: "avisos",
  num_users: "Nº de ususarios",
  optional: "opcional",
  orSelectCustomDateRange: "O selecciona rango de fechas personalizado",
  organization: "organización",
  other_deductions_pct: "Otros porcentages de deducciones",
  overclaimed: "conflicto de titularidad",
  password: "contraseña",
  password_recovery: "recuperar contraseña",
  payee: "beneficiario",
  pending: "pendiente",
  pending_for_validation: "pendiente de validación",
  people: "personas",
  period: "periodo",
  placeholderSoundRecording: "Este fonograma ha sido creado a partir de una entrada en un log de usos.",
  play_count: "Nº tocadas",
  playlist_not_found: "Fichero de playlist no encontrado",
  playlist_rematching: "Re-identificación de ficheros de playlist",
  playlist_rematching_check: "Selecciona para volver a identificar todos los ficheros de playlist incluidos en esta distribución.",
  playlist_rematching_desc: "Por defecto, la distribución utilizará la identificación actual en todos los ficheros de playlist.",
  playlist_set_allocable: "Playlist lista para distribución",
  playlist_will_be_matched_again: "ficheros seran",
  playlists: "playlist",
  please_indicate_a_recovery_email: "por favor indique un email",
  preDistributionWarning: "Sólo playlist basadas en duración serán utilizadas en el informe de pre-distribución",
  processing: "procesando",
  proposedCandidates: "candidatos propuestos",
  proprietary_id: "ID propietario / subido por",
  provider_id: "Provider id",
  re_allocate: "redistribución",
  readyForDistribution: "Preparado para distribución",
  reason: "razón",
  recording_unclaimed: "fonograma sin titularidad",
  regitry_line_1: "su petición será revisada",
  regitry_line_2: "Una vez aprobada recibirá un email para configurar su contraseña",
  regitry_line_3: "mantengase atento",
  regitry_line_4: "En breve recibirá noticias nuestras!",
  releaseNames: "Título del Álbum",
  remove: "eliminar",
  removeAllClaimsQuestion: "Quiere eliminar todos los fonogramas del listado de titularidades?",
  removeClaim: "eliminar titularidad",
  remove_all: "eliminar todos",
  repertoire: "repertorio",
  rightOwner: "propietario de los derechos",
  rightOwners: "propietarios de derechos",
  rightPeriod: "periodo de los derechos",
  rightTypes: "tipos de derechos",
  rights: "derechos",
  rule: "regla de distribución",
  save: "guardar",
  saveAsDraft: "guardar como borrador",
  save_member: "Save Member",
  save_member_warning: "Cambiar los mandatos/tipos de uso para este miembro actualizará las reclamaciones de titularidad existentes. Estos cambios pueden tardar unas horas en verse reflejados en la base de datos. ¿Está seguro?",
  search: "buscar",
  search_candidates: "buscar candidatos",
  select: "seleccionar",
  selectFileType: "seleccionar tipo de ficheros",
  selectFunds: "seleccionar fondos",
  selectMember: "seleccionar sello",
  selectPayee: "seleccionar beneficiario",
  selectPlaylists: "seleccionar playlist",
  selectRightOwner: "seleccionar propietario de los derechos",
  selectRightTypes: "seleccionar tipos de derechos",
  selectRule: "seleccionar regla",
  selectStatus: "seleccionar estado",
  selectUseType: "seleccionar tipo de derecho",
  select_all: "seleccionar todo",
  select_date: "seleccionar fecha",
  select_date_range: "seleccionar rango de fechas",
  select_member: "seleccionar sello",
  select_members: "seleccionar sellos",
  select_members_to_participate: "Seleccione miembros participantes",
  select_type: "seleccionar tipo",
  send: "enviar",
  send_notifications: "enviar avisos",
  setupNewDistribution: "Configurar nueva distribución",
  show: "mostrar",
  showIneligible: "mostrar no elegible",
  show_hidden: "mostrar ocultos",
  show_inactive: "mostrar inactivo",
  sign_up: "registrate",
  signup_header: "Por favor complete sus datos. La cuenta será revisada antes de ser dada de alta",
  society: "sociedad",
  soundRecordingDetail: "detalle fonograma",
  soundRecordingDetails: "detalles fonograma",
  soundRecordings: "fonogramas",
  soundSysDatabase: "BBDD de fonogramas",
  sound_recording_saved: "Fonograma guardado",
  sound_recordings_claimed: "Fonograma reclamado",
  soundrecordingDetail: "detalles fonograma",
  source: "Origen",
  sourceMetadata: "fuente metadatos",
  split: "propiedad",
  status: "estado",
  submittedBy: "enviado por",
  tax_deductions_pct: "Porcentaje de deducción de Impuestos",
  this_user_will_receive_all_notifications: "este usuario recibirá todos los avisos",
  this_user_will_receive_no_notifications: "este usuario no recibirá avisos",
  time_period: "periodo de tiempo",
  title: "titulo",
  to: "hasta",
  total: "total",
  total_unique: "total único",
  type: "tipo",
  un_select_all: "Des/Seleccionar Todo",
  unclaimed: "sin titularidad",
  underclaimed: "conflicto falta de titularidad",
  unmatched: "no identificado",
  unmatched_no_duplicates: "no identificado sin duplicados",
  unmatched_ready_for_distribution: "unmatched ready for distribution",
  upload: "cargar",
  uploadDate: "Fecha de carga",
  uploadFunds: "cargar fondos",
  uploadProRataFile: "cargar fichero pro-rata",
  uploads: "cargas",
  usageType: "tipo de derecho",
  usages: "Usos / Tocadas",
  useReleaseMatchingInfo: "Forzar el uso de la información del álbum en el proceo de identificación. CUIDADO: esto puede crear faslsos positivos",
  useType: "tipo de derecho",
  userProfile: "perfil de usuario",
  user_data: "datos de usuario",
  user_saved: "usuario guardado",
  user_type_not_defined: "tipo de usuario no definido",
  username: "nombre de usuario",
  users: "usuarios",
  validate: "validar",
  value: "valor",
  version: "versión",
  versionTitle: "título de la versión",
  view: "vista",
  view_excluded_members: "View Excluded Members",
  view_selected_members: "ver sellos seleccionados",
  view_selected_playlists: "ver playlist seleccionada",
  worldwide: "mundial",
  year: "año",
  yes: "si",
}
